<script>
export default {
  name: 'ReceivedNewUxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#BC4E4E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.94375 11.3687C3.00625 11.3937 3.0625 11.4062 3.125 11.4062H9.54375C9.8 11.4062 10.0125 11.1937 10.0125 10.9374C10.0125 10.6812 9.8 10.4687 9.54375 10.4687H4.25625L12.2063 2.51865C12.3875 2.3374 12.3875 2.0374 12.2063 1.85615C12.025 1.6749 11.725 1.6749 11.5437 1.85615L3.59375 9.80615V4.51865C3.59375 4.2624 3.38125 4.0499 3.125 4.0499C2.86875 4.0499 2.65625 4.2624 2.65625 4.51865V10.9374C2.65625 10.9999 2.66875 11.0562 2.69375 11.1187C2.7375 11.2312 2.83125 11.3249 2.94375 11.3687Z"
      :fill="color"
    />
    <path
      d="M12.8125 13.2812H2.1875C1.93125 13.2812 1.71875 13.4938 1.71875 13.75C1.71875 14.0063 1.93125 14.2188 2.1875 14.2188H12.8125C13.0688 14.2188 13.2812 14.0063 13.2812 13.75C13.2812 13.4938 13.0688 13.2812 12.8125 13.2812Z"
      :fill="color"
    />
  </svg>
</template>
